import React, { useState, useEffect } from 'react';
import Helmet from "react-helmet";
import { lang } from '../../il8n/lang';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import './Accordion.css';

const Accordion = ({ features, contents, contentsText, featuresText }) => {

    const [ clicked, setClicked ] = useState(false);

    const toggle = index => {
        if (clicked === index) {
            return setClicked(null)
        }

        setClicked(index);
    }

    const accordionData = [
        {
        title: features,
        content: featuresText,
    },
    {
        title: contents,
        content: contentsText,
    }
]

    return (
        <section className="accordion_section">
            <div className="accordion_container">
                {accordionData.map((item, index) => {
                    return (
                        <div 
                            className={"accordion_item " + (clicked === index ? 'open' : '')}
                            key={index}
                            onClick={() => toggle(index)}
                        >
                            <div className="accordion_title">
                                <h3>{item.title}</h3>
                                <div className="accordion-chevron">
                                    <FontAwesomeIcon icon={clicked === index ? faChevronUp : faChevronDown} className="accordion-chevron" />
                                </div>
                            </div>
                            { clicked === index ? (
                                <ul className={item.content === featuresText ? "accordion_content accordion_custom_margin" : "accordion_custom_margin"}>
                                    {item.content}
                                </ul>
                            ) : null }   
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default Accordion;